import React from "react";
import { Icon, IconName, NotificationBanner } from "halifax";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import "./styles.scss";
import { CustomerAccountRole, RewardsAccount } from "redmond";
import {
  getBenefitsList,
  LC_ADDITIONAL_BENEFITS,
  LC_BENEFITS_TITLE,
  PC_ADDITIONAL_BENEFITS,
  PC_BENEFITS_TITLE,
} from "./textConstants";
import {
  AVAILABLE,
  XMOD_V1_EXPERIMENT,
  getExperimentVariant,
  useExperiments,
} from "../../../../context/experiments";

export interface IPremierCollectionCheckoutBenefitsProps {
  className?: string;
  variant?: "premier-collection" | "lifestyle-collection";
  largestEarnAccount: RewardsAccount;
  isVR?: boolean;
  isPayLater?: boolean;
}
export const PremierCollectionCheckoutBenefits = ({
  className,
  variant = "premier-collection",
  largestEarnAccount,
  isVR = false,
  isPayLater = false,
}: IPremierCollectionCheckoutBenefitsProps) => {
  const expState = useExperiments();

  const isXmodRedesign = React.useMemo(
    () => getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) === AVAILABLE,
    [expState.experiments]
  );
  return (
    <Box className={clsx("pc-checkout-benefits-content-wrapper", className, { xmod: isXmodRedesign })}>
      <Box className="pc-benefits-title">
        <Icon name={IconName.StarOutline} />
        <Typography className="pc-benefits-title-text">
          {variant === "premier-collection" && PC_BENEFITS_TITLE}
          {variant === "lifestyle-collection" && LC_BENEFITS_TITLE}
        </Typography>
      </Box>

      <Typography className="pc-benefits-list">
        {getBenefitsList(
          largestEarnAccount.earn.hotelsMultiplier,
          variant === "lifestyle-collection",
          isVR,
          largestEarnAccount.customerAccountRole ===
            CustomerAccountRole.Primary,
          isPayLater,
          largestEarnAccount.rewardsBalance?.currencyDescription ||
            largestEarnAccount.rewardsBalance?.currency
        )}
      </Typography>
      <NotificationBanner
        icon={<Icon name={IconName.GiftOutline} />}
        content={
          variant === "premier-collection" || isVR
            ? PC_ADDITIONAL_BENEFITS(isVR)
            : LC_ADDITIONAL_BENEFITS
        }
      />
    </Box>
  );
};
